// extracted by mini-css-extract-plugin
export default {"root":"MarketingPageLayout_root__KtTg8","main":"MarketingPageLayout_main__CtMQV","mainLegacy":"MarketingPageLayout_mainLegacy__IHp1+"};